module.exports = __webpack_public_path__ + "img/provalus-logo.82891427.jpg";